import { useEffect, useState } from "react";
import "./Candidates.css";
import { CiSearch } from "react-icons/ci";
import useManageApplicants from "../../../hook/useManageApplicants";
import PaginationContainer from "../../../components/paginationContainer/PaginationContainer";
import CustomButton from "../../../components/customButton/CustomButton";
import { useNavigate, useParams } from "react-router-dom";
import { MdOutlineChevronLeft } from "react-icons/md";
import ApplicantsTable from "../../../components/applicantsTable/ApplicantsTable";
import FilterInput from "../../../components/filterBox/FilterInput";
import { Button } from "@mui/material";
import { GrPowerReset } from "react-icons/gr";

const Candidates = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [tag, setTag] = useState(params?.tag ? Number(params?.tag) : 0);
  const {
    data,
    loading,
    updateApplicant,
    refetch: manageRefetch,
    handleResolve,
    filters,
    setFilters,
  } = useManageApplicants();
  const applicants = data?.data;
  //console.log("data-a", applicants, filters);

  const [applicantsData, setApplicantsData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    if (tag === 0) setFilters((prev) => ({ ...prev, status: 1 }));
    else if (tag === 1) setFilters((prev) => ({ ...prev, status: 2 }));
    else if (tag === 2) setFilters((prev) => ({ ...prev, status: 3 }));
    else if (tag === 3) setFilters((prev) => ({ ...prev, status: 5 }));
    else if (tag === 4) setFilters((prev) => ({ ...prev, status: 6 }));
    else if (tag === 5) setFilters((prev) => ({ ...prev, status: 4 }));

    setApplicantsData(applicants?.data);
  }, [tag, applicants, params?.tag, setFilters]);

  const updateTag = (newTag) => {
    setTag(newTag);
    setSearchQuery("");
  };

  const onPageChange = (event, value) => {
    setFilters((prev) => ({ ...prev, page: value }));
  };

  const getStatus = (status) => {
    return [0, 1, 2].includes(status) ? "Pending" : "Accepted";
  };

  return (
    <div className="candidates-container">
      <div className="candidates-right">
        <CustomButton
          customStyles={{
            width: "95px",
            height: "40px",
            marginTop: "0",
            fontSize: "14px",
            borderRadius: "5px",
          }}
          title={
            <div style={{ display: "flex", alignItems: "center", gap: "0" }}>
              <MdOutlineChevronLeft size={20} />
              <span>Back</span>
            </div>
          }
          onClick={() => navigate(-1)}
        />
        <div className="candidates-content-box">
          <h2 className="heading-right-top">Applicants</h2>
          <div className="header">
            <div className="search-bar">
              <CiSearch />
              <input
                type="text"
                placeholder="Search candidates"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>

            <div className="date-listing">
              <div style={{ display: "flex", gap: 5, alignItems: "center" }}>
                <FilterInput
                  customStyles={{
                    bg: {
                      height: "35px",
                      backgroundColor: "#fff",
                      borderRadius: "4px",
                      border: "1px solid #D3D3D3",
                    },
                    input: {
                      width: "100%",
                    },
                  }}
                  placeholder="DD-MM-YYYY"
                  type="date"
                  value={filters.date_from}
                  onChange={(e) =>
                    setFilters((prev) => ({
                      ...prev,
                      date_from: e.target.value,
                    }))
                  }
                />
                <span>to</span>
                <FilterInput
                  customStyles={{
                    bg: {
                      height: "35px",
                      backgroundColor: "#fff",
                      borderRadius: "4px",
                      border: "1px solid #D3D3D3",
                    },
                    input: {
                      width: "100%",
                    },
                  }}
                  placeholder="DD-MM-YYYY"
                  type="date"
                  value={filters.date_to}
                  onChange={(e) =>
                    setFilters((prev) => ({
                      ...prev,
                      date_to: e.target.value,
                    }))
                  }
                />
              </div>

              <Button
                onClick={() => {
                  setSearchQuery("");
                  setFilters((prev) => ({
                    ...prev,
                    date_from: "",
                    date_to: "",
                  }));
                }}
                style={{
                  backgroundColor: "transparent",
                  border: "1px solid #D3D3D3",
                  height: "35px",
                  minWidth: "30px",
                }}
              >
                <GrPowerReset />
              </Button>
            </div>
          </div>

          <div className="candidates-options-box">
            <div className="options-left">
              <div
                onClick={() => {
                  updateTag(0);
                }}
                className={tag === 0 ? "active" : "non-active"}
              >
                <span>Applied</span>
              </div>
              <div
                className={tag === 1 ? "active" : "non-active"}
                onClick={() => {
                  updateTag(1);
                }}
              >
                <span>Shortlisted</span>
              </div>
              <div
                className={tag === 2 ? "active" : "non-active"}
                onClick={() => {
                  updateTag(2);
                }}
              >
                <span>Updated Timesheet</span>
              </div>
              <div
                className={tag === 3 ? "active" : "non-active"}
                onClick={() => {
                  updateTag(3);
                }}
              >
                <span>Ongoing</span>
              </div>

              <div
                className={tag === 4 ? "active" : "non-active"}
                onClick={() => {
                  updateTag(4);
                }}
              >
                <span>Completed</span>
              </div>

              <div
                className={tag === 5 ? "active" : "non-active"}
                onClick={() => {
                  updateTag(5);
                }}
              >
                <span>Declined</span>
              </div>
            </div>
            <div className="options-right">
              <p>
                Showing {applicantsData?.length ?? 0} out of{" "}
                {applicants?.meta?.allCount ?? 0} applications
              </p>
            </div>
          </div>

          <PaginationContainer
            loading={loading}
            data={applicantsData ?? []}
            onPageChange={onPageChange}
            page={filters.page}
            total={applicants?.meta?.allCount ?? 0}
          >
            <ApplicantsTable
              data={applicantsData}
              tag={tag}
              setTag={setTag}
              updateApplicant={updateApplicant}
              status={getStatus(tag)}
              manageRefetch={manageRefetch}
              handleResolve={handleResolve}
            />
          </PaginationContainer>
        </div>
      </div>
    </div>
  );
};

export default Candidates;
